import axios from 'axios';
class VendorService {
    axiosInstances;
    static auth;
    static config;
    static vendors = [];
    constructor(auth, axiosInstances, config) {
        this.axiosInstances = axiosInstances;
        VendorService.auth = auth;
        VendorService.config = config;
    }
    headers() {
        return {
            Authorization: `Bearer ${VendorService.auth.currentToken}`,
        };
    }
    adminPortal = {
        activity: {
            query: async (query) => {
                const { data } = await this.axiosInstances.mainInstance.get('/hauler/admin-portal/activity', {
                    params: query,
                });
                return data;
            },
        },
        /**
         * Get a map of vendor IDs to names. Optionally filter by haulerID (comma-separated).
         */
        getVendorNameMap: async (haulerIDs) => {
            const { data } = await this.axiosInstances.mainInstance.get('/hauler/admin-portal/vendor-name-map', {
                params: haulerIDs?.length ? { haulerID: haulerIDs.join(',') } : undefined,
            });
            return data;
        },
        query: async (query) => {
            const { data } = await this.axiosInstances.mainInstance.get('/hauler/admin-portal', {
                params: query,
            });
            VendorService.vendors = data;
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axiosInstances.mainInstance.get(`/hauler/admin-portal/${id}`);
            return data;
        },
        create: async (input) => {
            const { data } = await this.axiosInstances.mainInstance.post('/hauler/admin-portal', input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axiosInstances.mainInstance.put(`/hauler/admin-portal/${id}`, input);
            return data;
        },
        contacts: {
            create: async (input) => {
                const { data } = await this.axiosInstances.mainInstance.post('/hauler/admin-portal/sap-contact', input);
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axiosInstances.mainInstance.patch(`/hauler/admin-portal/sap-contact/${id}`, input);
                return data;
            },
            delete: async (id) => {
                const { data } = await this.axiosInstances.mainInstance.delete(`/hauler/admin-portal/sap-contact/${id}`);
                return data;
            },
        },
        /**
         * Assign a pricing zone to a dispatch contact
         */
        createSapContactPricingZone: async (input) => {
            const { data } = await this.axiosInstances.mainInstance.post('/hauler/admin-portal/sap-contact-pricing-zone', input);
            return data;
        },
        /**
         * Remove a pricing zone assignment from a dispatch contact
         * @param id - The assignment ID (from pricingZones[].id), NOT the pricingZoneId
         */
        deleteSapContactPricingZone: async (id) => {
            const { data } = await this.axiosInstances.mainInstance.delete(`/hauler/admin-portal/sap-contact-pricing-zone/${id}`);
            return data;
        },
    };
    wayste = {
        partnerPortal: {
            contacts: {
                create: async (input) => {
                    const { data } = await this.axiosInstances.mainInstance.post('/hauler/wayste/partner-data/contact', input);
                    return data;
                },
                update: async (id, input) => {
                    const { data } = await this.axiosInstances.mainInstance.patch(`/hauler/wayste/partner-data/contact/${id}`, input);
                    return data;
                },
                delete: async (id) => {
                    const { data } = await this.axiosInstances.mainInstance.delete(`/hauler/wayste/partner-data/contact/${id}`);
                    return data;
                },
            },
            files: {
                update: async (input) => {
                    const { data } = await this.axiosInstances.mainInstance.patch('/hauler/wayste/partner-data/add-files', input);
                    return data;
                },
            },
        },
    };
    /**
     * V2 vendor profile endpoints — maps to /hauler/v2/vendor-profiles
     */
    v2 = {
        list: async (query) => {
            const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/vendor-profiles', { params: query });
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axiosInstances.mainInstance.get(`/hauler/v2/vendor-profiles/${id}`);
            return data;
        },
        nameMap: async (haulerIDs) => {
            const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/vendor-profiles/name-map', {
                params: haulerIDs?.length ? { haulerID: haulerIDs.join(',') } : undefined,
            });
            return data;
        },
        summary: async () => {
            const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/vendor-profiles/summary');
            return data;
        },
        activity: async (query) => {
            const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/vendor-profiles/activity', { params: query });
            return data;
        },
        create: async (input) => {
            const { data } = await this.axiosInstances.mainInstance.post('/hauler/v2/vendor-profiles', input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axiosInstances.mainInstance.put(`/hauler/v2/vendor-profiles/${id}`, input);
            return data;
        },
        contacts: {
            create: async (vendorID, input) => {
                const { data } = await this.axiosInstances.mainInstance.post(`/hauler/v2/vendor-profiles/${vendorID}/contacts`, input);
                return data;
            },
            update: async (vendorID, contactId, input) => {
                const { data } = await this.axiosInstances.mainInstance.patch(`/hauler/v2/vendor-profiles/${vendorID}/contacts/${contactId}`, input);
                return data;
            },
            delete: async (vendorID, contactId) => {
                const { data } = await this.axiosInstances.mainInstance.delete(`/hauler/v2/vendor-profiles/${vendorID}/contacts/${contactId}`);
                return data;
            },
        },
        documents: {
            /**
             * GET /hauler/v2/vendor-profiles/:profileId/documents
             * List paginated vendor documents. Returns signed S3 URLs.
             * Admin sees all; hauler-admin sees only visible_to_vendor=true.
             */
            list: async (profileId, params) => {
                const { data } = await this.axiosInstances.mainInstance.get(`/hauler/v2/vendor-profiles/${profileId}/documents`, { params });
                return data;
            },
            /**
             * POST /hauler/v2/vendor-profiles/:profileId/documents
             * Create a vendor document. Checksum enables duplicate detection (warn, don't block).
             */
            create: async (profileId, body) => {
                const { data } = await this.axiosInstances.mainInstance.post(`/hauler/v2/vendor-profiles/${profileId}/documents`, body);
                return data;
            },
            /**
             * PUT /hauler/v2/vendor-profiles/:profileId/documents/:docId
             * Update document metadata (type, notes, expiration, status, visible_to_vendor).
             */
            update: async (profileId, docId, body) => {
                const { data } = await this.axiosInstances.mainInstance.put(`/hauler/v2/vendor-profiles/${profileId}/documents/${docId}`, body);
                return data;
            },
            /**
             * DELETE /hauler/v2/vendor-profiles/:profileId/documents/:docId
             * Remove a vendor document.
             */
            delete: async (profileId, docId) => {
                const { data } = await this.axiosInstances.mainInstance.delete(`/hauler/v2/vendor-profiles/${profileId}/documents/${docId}`);
                return data;
            },
        },
        documentTypes: {
            /**
             * GET /hauler/v2/document-types
             * List all active document types (for populating type dropdowns).
             */
            list: async () => {
                const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/document-types');
                return data;
            },
        },
        scores: {
            /** GET /hauler/v2/vendor-profiles/:profileId/scores — SourScores with rating breakdowns for a vendor. */
            get: async (profileId) => {
                const { data } = await this.axiosInstances.mainInstance.get(`/hauler/v2/vendor-profiles/${profileId}/scores`);
                return data;
            },
        },
        compliance: {
            /**
             * GET /hauler/v2/compliance/categories
             * List all compliance categories with their nested issues.
             */
            listCategories: async () => {
                const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/compliance/categories');
                return data;
            },
        },
        scoreRatingConfigs: {
            /**
             * GET /hauler/v2/score-rating-configs
             * List active score rating configs (optionally filtered by serviceType / manuallyReportable).
             */
            list: async (params) => {
                const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/score-rating-configs', { params });
                return data;
            },
        },
        vendorEvents: {
            /**
             * POST /hauler/v2/vendor-events/recommend-rules
             * AI-powered endpoint that recommends which compliance rules were broken based on a description.
             */
            recommendRules: async (description, serviceType) => {
                const { data } = await this.axiosInstances.mainInstance.post('/hauler/v2/vendor-events/recommend-rules', { description, serviceType });
                return data;
            },
            /**
             * GET /hauler/v2/vendor-profiles/:profileId/vendor-events
             * List paginated vendor events for a specific vendor profile.
             */
            list: async (profileId, params) => {
                const { data } = await this.axiosInstances.mainInstance.get(`/hauler/v2/vendor-profiles/${profileId}/vendor-events`, { params });
                return data;
            },
            /**
             * GET /hauler/v2/vendor-events
             * List paginated vendor events across all vendors.
             */
            listAll: async (params) => {
                const { data } = await this.axiosInstances.mainInstance.get('/hauler/v2/vendor-events', { params });
                return data;
            },
            /**
             * POST /hauler/v2/vendor-profiles/:profileId/vendor-events
             * Create a vendor event against a vendor profile.
             */
            create: async (profileId, body) => {
                const { data } = await this.axiosInstances.mainInstance.post(`/hauler/v2/vendor-profiles/${profileId}/vendor-events`, body);
                return data;
            },
            /**
             * PATCH /hauler/v2/vendor-events/:eventId
             * Update a vendor event (status, description, assignment, etc.).
             */
            update: async (eventId, body) => {
                const { data } = await this.axiosInstances.mainInstance.patch(`/hauler/v2/vendor-events/${eventId}`, body);
                return data;
            },
            /**
             * GET /hauler/v2/vendor-profiles/:profileId/vendor-events/summary
             * Get vendor event summary (counts, escalation stages) for a vendor.
             */
            summary: async (profileId) => {
                const { data } = await this.axiosInstances.mainInstance.get(`/hauler/v2/vendor-profiles/${profileId}/vendor-events/summary`);
                return data;
            },
        },
    };
    appAdmin = {
        create: async (input) => {
            const { data } = await this.axiosInstances.appAdminInstance.post('/hauler/admin-portal', input);
            return data;
        },
    };
    /**
     * @deprecated Use `adminPortal.query` instead.
     */
    async fetch() {
        const response = await axios({
            method: 'GET',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal`,
            headers: this.headers(),
        });
        VendorService.vendors = response.data;
        return response;
    }
    /**
     * @deprecated Use `adminPortal.fetchById` instead.
     */
    async fetchById(id) {
        const response = await axios({
            method: 'GET',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal/${id}`,
            headers: this.headers(),
        });
        return response;
    }
    /**
     * @deprecated Use `adminPortal.create` instead.
     */
    async create(data) {
        const response = await axios({
            method: 'POST',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal`,
            headers: this.headers(),
            data: data,
        });
        return response.data;
    }
    /**
     * @deprecated Use `adminPortal.update` instead.
     */
    async update(id, data) {
        const response = await axios({
            method: 'PUT',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal/${id}`,
            headers: this.headers(),
            data: data,
        });
        return response;
    }
}
export default VendorService;
//# sourceMappingURL=Vendor.service.js.map